import axios from 'axios'
import { capturarErro } from './monitoramento'

const api = axios.create({
              baseURL:'/',
              headers: {
                'Accept': 'application/json'
              }
            })

api.interceptors.request.use((config) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content

  if (token) config.headers['X-CSRF-Token'] = token

  return config
})

api.interceptors.response.use((resposta) => resposta, (erro) => {
  capturarErro(erro, { fluxo: erro?.config?.fluxo })

  return Promise.reject(erro)
})

export { api }
